export default __webpack_public_path__ + "static/media/reload.15dfa47f.svg";